<aside
  class="fixed top-0 left-0 z-20 h-screen bg-transparent text-white transition-all duration-300 flex flex-col"
  [ngClass]="{ 'w-56': mode === 'large', 'w-20': mode === 'small' }">
  <div class="flex flex-col items-center justify-center h-[120px] border-b border-white/10 px-3">
    <img
      *ngIf="mode === 'large'"
      src="assets/nSideLogoNoTagline-WHITE.png"
      alt="nSide"
      class="h-10 w-auto" />
      <h1 *ngIf="mode === 'large'" class="oswald-font text-2xl">Admin Tools</h1>
    <img
      *ngIf="mode === 'small'"
      src="assets/nLogo-WHITE.png"
      alt="nSide"
      class="h-10 w-auto" />
  </div>

  <nav class="px-2 py-4 flex-1 overflow-y-auto">
    <ul class="space-y-1">
      <li>
        <button
          type="button"
          (click)="navigateToPage('')"
          class="w-full flex items-center gap-3 px-3 py-2 transition-colors rounded-md"
          [ngClass]="pageRoute === ''
            ? 'bg-white/60 text-nside-gray-400'
            : 'text-white hover:bg-white/10'">
          <lucide-icon [img]="icons.Home" [size]="20"></lucide-icon>
          <span [ngClass]="{ 'block': mode === 'large', 'hidden': mode === 'small' }">
            Home
          </span>
        </button>
      </li>
      <!-- <li>
        <button
          type="button"
          (click)="navigateToPage('360-bulk-upload')"
          class="w-full flex items-center gap-3 px-3 py-2 transition-colors rounded-md"
          [ngClass]="pageRoute === '360-bulk-upload'
            ? 'bg-white/60 text-nside-gray-400'
            : 'text-white hover:bg-white/10'">
          <lucide-icon [img]="icons.Fullscreen" [size]="20"></lucide-icon>
          <span [ngClass]="{ 'block': mode === 'large', 'hidden': mode === 'small' }">
            360 Bulk Upload
          </span>
        </button>
      </li>
      <li>
        <button
          type="button"
          (click)="navigateToPage('maps')"
          class="w-full flex items-center gap-3 px-3 py-2 transition-colors rounded-md"
          [ngClass]="pageRoute === 'maps'
            ? 'bg-white/60 text-nside-gray-400'
            : 'text-white hover:bg-white/10'">
          <lucide-icon [img]="icons.MapPin" [size]="20"></lucide-icon>
          <span [ngClass]="{ 'block': mode === 'large', 'hidden': mode === 'small' }">
            Maps (beta)
          </span>
        </button>
      </li> -->
      <li>
        <button
          type="button"
          (click)="navigateToPage('fleet')"
          class="w-full flex items-center gap-3 px-3 py-2 transition-colors rounded-md"
          [ngClass]="pageRoute === 'fleet'
            ? 'bg-white/60 text-nside-gray-400'
            : 'text-white hover:bg-white/10'">
          <lucide-icon [img]="icons.Bus"></lucide-icon>
          <span [ngClass]="{ 'block': mode === 'large', 'hidden': mode === 'small' }">
            Fleet
          </span>
        </button>
      </li>
      <li>
        <button
          type="button"
          (click)="openIdentity()"
          class="w-full flex items-center gap-3 px-3 py-2 transition-colors rounded-md text-white hover:bg-white/10">
          <lucide-icon [img]="icons.FileUser"></lucide-icon>
          <span [ngClass]="{ 'block': mode === 'large', 'hidden': mode === 'small' }">
            Admin Identity
          </span>
        </button>
      </li>
      <li>
        <button
          type="button"
          (click)="openPlatform()"
          class="w-full flex items-center gap-3 px-3 py-2 transition-colors rounded-md text-white hover:bg-white/10">
          <lucide-icon [img]="icons.DoorOpen"></lucide-icon>
          <span [ngClass]="{ 'block': mode === 'large', 'hidden': mode === 'small' }">
            nSide Platform
          </span>
        </button>
      </li>
    </ul>
  </nav>

  <div class="px-2 py-4">
    <button
      type="button"
      (click)="logout()"
      class="w-full flex items-center gap-3 px-3 py-2 transition-colors rounded-md text-white hover:bg-white/10">
      <lucide-icon [img]="icons.LogOut" [size]="20"></lucide-icon>
      <span [ngClass]="{ 'block': mode === 'large', 'hidden': mode === 'small' }">
        Logout
      </span>
    </button>
  </div>

  <button
    type="button"
    (click)="toggle()"
    class="absolute top-8 -right-3 w-6 h-6 rounded-full bg-white text-nside-gray-400 shadow-custom-1 flex items-center justify-center cursor-pointer">
    <lucide-icon
      [img]="icons.ChevronLeft"
      [size]="14"
      [ngClass]="{ 'rotate-180': mode === 'small' }"
      class="transition-transform">
    </lucide-icon>
  </button>
</aside>
